import CollectedInformation from './components/collected-information/collected-information';
import Contact from './components/contact/contact';
import DataSecurity from './components/data-security/data-security';
import Legislation from './components/legislation/legislation';
import ResumeTable from './components/resume-table/resume-table';
import RetainedInformation from './components/retained-nformation/retained-nformation';
import SharedData from './components/shared-data/shared-data';
import UseOfCookies from './components/use-of-cookies/use-of-cookies';
import UsedInformation from './components/used-information/used-information';
import YourRights from './components/your-rights/your-rights';
import './policy.scss';

export default function Policy() {
    const googlePlayLink = (
        <a
            href="https://play.google.com/store/apps/details?id=br.com.ambevtech.smartcargas"
            target="_blank"
            rel="noreferrer"
        >
            Google Play
        </a>
    );

    const appStoreLink = (
        <a
            href="https://apps.apple.com/br/app/smart-cargas-2-0/id6448926270"
            target="_blank"
            rel="noreferrer"
        >
            Apple Store
        </a>
    );

    return (
        <div className="policy-page">
            <header className="policy-header">
                <h1>POLÍTICA DE PRIVACIDADE E PROTEÇÃO DE DADOS</h1>
            </header>

            <body>
                <p>
                    A AMBEV S.A., pessoa jurídica de direito privado inscrita no
                    CNPJ sob o nº 07.526.557/0001-00, com sede em São Paulo/SP
                    (“AMBEV”), considera relevantes os registros eletrônicos e
                    dados disponibilizados por você (“Usuário”) na utilização do
                    App Smart Cargas, disponíveis nas lojas por meio dos links:{' '}
                    {appStoreLink} e {googlePlayLink}, servindo a presente
                    Política de Privacidade (“Política”) para regular, de forma
                    simples, transparente e objetiva, quais dados e informações
                    serão obtidos, assim como quando os mesmos poderão ser
                    utilizados pela AMBEV.
                </p>
                <p>
                    O Smart Cargas é uma iniciativa da AMBEV, pela qual ela
                    presta um serviço de aceite/confirmação de cargas aos
                    transportadores, trazendo praticidade em suas rotinas.
                </p>
                <p>
                    Para melhor ilustrar a forma como realizamos o tratamento
                    dos dados, apresentamos um resumo de nossa Política de
                    Privacidade e Proteção de Dados Pessoais (“Política”):
                </p>

                <ResumeTable />
                <CollectedInformation />
                <UsedInformation />
                <UseOfCookies />
                <SharedData />
                <DataSecurity />
                <RetainedInformation />
                <YourRights />
                <Contact />
                <Legislation />
            </body>

            <footer className="policy-footer">
                © Ambev 2025. Todos os direitos reservados
            </footer>
        </div>
    );
}
